import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../views/Home/home/HomePage.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/change-station",
      name: "change-station",
      component: () => import("../views/ChangeStation/ChangeStation.vue"),
    },
    {
      path: "/how-it-works",
      name: "about",
      component: () => {
        return import("../views/Home/about/PublicAbout.vue");
      },
    },
    // Some test page
    {
      path: "/test",
      name: "test",
      component: () => import("../views/TestPage/SalesBoard.vue"),
    },
    // Design System pages
    {
      path: "/design-system",
      name: "design-system",
      component: () => import("../views/DesignSystem/DesignSystem.vue"),
    },
    {
      path: "/design-system/colors",
      name: "colors",
      component: () => import("../views/DesignSystem/SubPages/Colors.vue"),
    },
    {
      path: "/design-system/typography",
      name: "typography",
      component: () => import("../views/DesignSystem/SubPages/Typography.vue"),
    },
    {
      path: "/design-system/icons",
      name: "icons",
      component: () => import("../views/DesignSystem/SubPages/Icons.vue"),
    },
    {
      path: "/design-system/shadows",
      name: "shadows",
      component: () => import("../views/DesignSystem/SubPages/Shadows.vue"),
    },
    {
      path: "/design-system/buttons",
      name: "buttons",
      component: () => import("../views/DesignSystem/SubPages/Buttons.vue"),
    },
    {
      path: "/design-system/ui",
      name: "ui",
      component: () => import("../views/DesignSystem/SubPages/UI.vue"),
    },
    {
      path: "/design-system/cards",
      name: "cards",
      component: () => import("../views/DesignSystem/SubPages/Cards.vue"),
    },
    {
      path: "/design-system/input",
      name: "input",
      component: () => import("../views/DesignSystem/SubPages/Input.vue"),
    },
    // Real pages
    {
      path: "/sales-board",
      name: "sales board",
      component: () => import("../views/SalesBoard/SalesBoard.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/order/:orderID/:saleID",
      name: "order",
      component: () => import("../views/Order/Order.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/order/:id",
      name: "order details",
      component: () => import("../views/OrderDetails/OrderDetails.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/my-orders",
      name: "my orders",
      component: () => import("../views/MyOrders/MyOrders.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/orders-history",
      name: "orders-history",
      component: () => import("../views/OrdersHistory/OrdersHistory.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/charges",
      name: "charges",
      component: () => import("../views/Charges/Charges.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("../views/Profile/Profile.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/product-scale",
      name: "product scale",
      component: () => import("../views/ProductScale/ProductScale.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/payment-methods",
      name: "payment methods",
      component: () => import("../views/PaymentMethods/PaymentMethods.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("../views/Contact/ContactWrapper.vue"),
    },
    {
      path: "/sale-example",
      name: "sale example",
      component: () => import("../views/Home/example sale/ExampleSale.vue"),
    },
    {
      path: "/policy",
      name: "policy",
      component: () => {
        const token = localStorage.getItem("token");
        if (token) {
          return import("../views/Policy/Policy.vue");
        } else {
          return import("../views/Home/policy/PublicPolicy.vue");
        }
      },
    },
    {
      path: "/return-policy",
      name: "return policy",
      component: () => {
        const token = localStorage.getItem("token");
        if (token) {
          return import("../views/Policy/ReturnPolicy.vue");
        } else {
          return import("../views/Home/policy/PublicReturnPolicy.vue");
        }
      },
    },
    {
      path: "/stations",
      name: "stations",
      component: () => import("../views/Home/stations/StationsPublic.vue"),
    },
    {
      path: "/calendar",
      name: "calendar",
      component: () => import("../views/Home/Calendar/CalendarPublic.vue"),
    },
    {
      path: "/faq",
      name: "faq",
      component: () => {
        const token = localStorage.getItem("token");
        if (token) {
          return import("../views/Faq/Faq.vue");
        } else {
          return import("../views/Home/faq/PublicFaq.vue");
        }
      },
    },

    {
      path: "/schedule",
      name: "schedule",
      component: () => import("../views/Schedule/Schedule.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/RegistrationPages/LogIn.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/login-phone",
      name: "login for phone members",
      component: () => import("../views/RegistrationPages/LogInPhone.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/new-password/:code",
      name: "new password",
      component: () => import("../views/RegistrationPages/NewPassword.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/reset-password",
      name: "reset password",
      component: () => import("../views/RegistrationPages/ResetPassword.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/sign-up",
      name: "sign up",
      component: () => import("../views/RegistrationPages/SignUp.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/complete-registration",
      name: "complete registration",
      component: () =>
        import("../views/RegistrationPages/CompleteRegistration.vue"),
      // meta: {requiresAuth: true},
    },
    {
      path: "/find-station",
      name: "find station",
      component: () => import("../views/RegistrationPages/FindStation.vue"),
      // meta: {requiresAuth: true},
    },
    {
      path: "/send-email-verification",
      name: "send email verification",
      component: () =>
        import("../views/RegistrationPages/SendEmailVerification.vue"),
      // meta: { requiresAuth: true },
    },
    {
      path: "/phone-verification",
      name: "phone verification",
      component: () =>
        import("../views/RegistrationPages/PhoneVerification.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/code-verification/:token",
      name: "code verification",
      component: () => import("../views/RegistrationPages/CodeConfirm.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/email-verification/:id",
      name: "email verification",
      component: () =>
        import("../views/RegistrationPages/EmailVerification.vue"),
      // meta: { requiresAuth: true },
    },
    // Admin impersonation landing — intentionally no requiresAuth/requiresGuest
    // meta: an already-logged-in browser must reach it to switch sessions.
    {
      path: "/impersonate",
      name: "impersonate",
      component: () => import("../views/RegistrationPages/Impersonate.vue"),
    },
    // {
    //   path: "/email-verification-unsuccessful",
    //   name: "email verification unsuccessful",
    //   component: () =>
    //     import("../views/RegistrationPages/EmailVerificationUnsuccessful.vue"),
    //   // meta: { requiresAuth: true },
    // },
    // Support / Tickets
    {
      path: "/support",
      redirect: "/support/tickets",
    },
    {
      path: "/support/tickets",
      name: "support tickets",
      component: () => import("../views/Support/TicketsList.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/support/tickets/new",
      name: "support tickets new",
      component: () => import("../views/Support/TicketNew.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/support/tickets/:id",
      name: "support ticket thread",
      component: () => import("../views/Support/TicketThread.vue"),
      meta: { requiresAuth: true },
    },
    // Public poll page — auth check is handled inside the component:
    // unauthenticated users see a "not found" state (no redirect).
    {
      path: "/polls/:id",
      name: "poll",
      component: () => import("../views/Polls/PollPublicView.vue"),
    },
    //a wildcard route to catch all unmatched
    {
      path: "/:catchAll(.*)",
      redirect: { name: "" },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if the user is logged in ( toke exists )
    const token = localStorage.getItem("token");
    if (!token) {
      // If the user is not logged in, redirect
      next({ name: "home" });
    } else {
      // If the user is logged in, proceed to the private page
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    // Check if the route requires guest (not logged in)
    const token = localStorage.getItem("token");
    if (token) {
      // If the user is already logged in, redirect to the private page
      next({ name: "sales board" });
    } else {
      // If the user is not logged in, proceed to the public page or login page
      next();
    }
  } else {
    // For routes that do not require authentication or guest status, proceed as usual
    next();
  }
});

router.onError((error, to) => {
  if (
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Importing a module script failed")
  ) {
    window.location = to.fullPath;
  }
});

export default router;
